// extracted by mini-css-extract-plugin
export default {"status":"ConversationResetDemoVoice_status__411CY","replies":"ConversationResetDemoVoice_replies__w28tc"};